import { useEffect, useRef, useState } from "react";
import styles from "./HeaderWorldCup.module.css";

const cleanUrl = (url) => {
    if (typeof url !== 'string') return url;
    const domainUrl = process.env.NEXT_PUBLIC_IMAGE_DOMAIN.replace(/https?:\/\//, ''); // Extrae el dominio sin protocolo
    return url
      .replace(/images\.clarin\.com/g, domainUrl) // Cambia el dominio
      .replace(/^http:\/\//i, 'https://');               // Asegura HTTPS
  };

const HeaderWorldCup = ({
  imageMobile,
  imageDesktop,
  headerTitle,
  noteUrl,
  noteTitle,
  datetime,
  countdownTitle,
  description, 
  titleColor = false
}) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const intervalRef = useRef(null);

  const secureDesktop = cleanUrl(imageDesktop);
  const secureMobile = cleanUrl(imageMobile);


  useEffect(() => {
    if (!datetime) return;

    const calculateTimeLeft = () => {
      const difference = new Date(datetime) - new Date();

      if (difference <= 0) {
        clearInterval(intervalRef.current);
        setTimeLeft(null);
        return;
      }

      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
      });
    };

    calculateTimeLeft();
    intervalRef.current = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(intervalRef.current);
  }, [datetime]);

  const formatNumber = (number) => String(number).padStart(2, "0");

  return (
    <div className={styles.headerMundial + (titleColor ? ` ${styles.backgroundWhite}` : ` ${styles.backgroundBlack}`)}>
      <div className={styles.headerMundialNewsContainer}>
        <a
          className={styles.headerMundialNewsSection}
          href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/deportes`}
        >
          Clarín deportes
        </a>

        {noteTitle && noteUrl && (
            <a className={styles.headerMundialNews} href={noteUrl}>
              <span className={styles.headerMundialNewsMarquee}>
                {noteTitle}
              </span>
            </a>
        )}
      </div>
  <div className={styles.titleBox}>
            {headerTitle && (
            <h1 className={styles.headerMundialTitle}>{headerTitle}</h1>
            )}
            {description && (
              <h2 className={styles.headerdescriptionTitle}>
                {description}
              </h2>
            )}
          </div>
      {(secureMobile || secureDesktop) && (
        <div className={styles.headerMundialPictureContainer}>
          <picture className={styles.headerMundialPicture}>
            <source media="(min-width: 1024px)" srcSet={secureDesktop} />
            <img
              src={secureMobile || secureDesktop}
              alt={headerTitle || "Header Mundial"}
            />
          </picture>
        

        </div>
      )}

      {datetime && timeLeft && (
        <div className={styles.headerMundialCountdownContainer}>
          <div className={styles.headerMundialCountdown}>
            <p className={styles.headerMundialCountdownItem}>
              <span className={styles.headerMundialCountdownItemBold}>
                {formatNumber(timeLeft.days)}
              </span>
              <span>DIAS</span>
            </p>
            <p className={styles.headerMundialCountdownItem}>
              <span className={styles.headerMundialCountdownItemBold}>
                {formatNumber(timeLeft.hours)}
              </span>
              <span>HORAS</span>
            </p>
            <p className={styles.headerMundialCountdownItem}>
              <span className={styles.headerMundialCountdownItemBold}>
                {formatNumber(timeLeft.minutes)}
              </span>
              <span>MINUTOS</span>
            </p>
             {countdownTitle && (
            <p className={styles.headerMundialCountdownTitle}>
              {countdownTitle}
            </p>
          )}
          </div>
         
        </div>
      )}
    </div>
  );
};

export default HeaderWorldCup;
